

import { Checkbox, Col, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { updatePaymentgetwayRequest } from "../../api/api";
import { useAppSelector, useAppDispatch } from "../../redux/store/storehooks";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { useNavigate } from 'react-router-dom';
import { CheckboxChangeEvent } from "antd/lib/checkbox";


const NewPaymentParcik = () => {
    var dataRequestPay: any
    const [data, setData] = useState<any[]>([]);
    const [labNameValid, setLabNameValid] = useState('')
    const columns: ColumnsType<any> = [
        { title: 'کد مرکز', dataIndex: 'prk_AndriodLab_AutoID', key: 'prk_AndriodLab_AutoID' },
        { title: 'نام', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName' },
    ];
    const navigate = useNavigate();
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(true);

    const [inputValues, setInputValue] = useState({
        desc: ""
    });
    const [isTestgetway, setCheckedisTestgetway] = useState(true);
    const [isUseParsipolSSl, setisUseParsipolSSl] = useState(false);

    const [validation, setValidation] = useState({
        desc: ""


    });

    //handle submit updates
    function handleChange(event: any) {

        const { name, value } = event.target;
        if (event.target.type == "checkbox") {
            setInputValue({ ...inputValues, [name]: event.target.checked });
        }
        else
            setInputValue({ ...inputValues, [name]: value });

    }
    useEffect(() => {
        
      
    }, [])
    const newPay = (e: any) => {
        
if(!isTestgetway){
    errorNotify('تا زمانی که تست پرداخت انجام نشود امکان ثبت ندارید',undefined,3000)
    return
}

        setIsLoading(true);
        updatePaymentgetwayRequest(dataModel())
            .then((result: any) => {
                navigate("/parsicuser/RequestPayment");
                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                setIsLoading(false);

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)

            })
    }
    const onChangeisTestgetway = (e: CheckboxChangeEvent) => {

        setCheckedisTestgetway(e.target.checked);
        if (!e.target.checked)
            errorNotify('تا زمانی که تست پرداخت انجام نشود امکان ثبت ندارید', undefined, 3000)
    };
    const onChangeisUseParsipolSSl = (e: CheckboxChangeEvent) => {

        setisUseParsipolSSl(e.target.checked);
    };
    const dataModel = () => {
        
        let model: any = {}
        model.requestId = myStore.requestPaymen.requestPaymen.prk_PaymentgetwayRequest_AutoID
        model.labId = myStore.requestPaymen.requestPaymen.frk_LabId
        model.approveUseId = myStore.auth.userId
        model.isTestgetway = isTestgetway
        model.isUseParsipolSSl = isUseParsipolSSl
        model.desc = inputValues.desc
        return model
    }
    return (

        <>
            <Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                    <div className="form-control"
                        style={{ marginBottom: '18px', direction: 'rtl' }} >
                        <input
                            placeholder="توضیحات"
                            type="string"
                            autoComplete="false"
                            name="desc"
                            style={{ background: '#ffffff', direction: 'ltr', border: '1px solid' }}
                            id="desc"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.desc}

                        />


                        <Checkbox checked={isTestgetway} onChange={onChangeisTestgetway}>آیا تست پرداخت انجام شده ؟</Checkbox>
                        <Checkbox style={{ marginRight: '20px' }}
                            checked={isUseParsipolSSl} onChange={onChangeisUseParsipolSSl}>آیا از  ssl  شرکت استفاده میکند ؟</Checkbox>
                    </div>

                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                    <div className="form-control"
                        style={{ marginBottom: '18px', textAlign: 'center' }} >
                        <button
                            onClick={(e) => newPay(e)}
                            style={{ 'background': 'green', 'color': 'white', padding: '7px', border: 'none', borderRadius: '7px' }}
                        >ثبت اطلاعات</button>



                    </div>
                </Col>
            </Row>
        </>
    );
};

export default NewPaymentParcik